import { api } from './api';
import { 
  ShareDocumentRequest, 
  DocumentParticipantsResponse, 
  DocumentActivityLog,
  DocumentRole 
} from '../types/documentSharing';
import { MailMessage } from '../types/mail';

export const documentSharingApi = {
  // Поделиться документом
  shareDocument: async (request: ShareDocumentRequest): Promise<MailMessage> => {
    const response = await api.post('/DocumentSharing/share', request);
    return response.data;
  },

  // Получить участников документа
  getParticipants: async (knowledgeItemId: string): Promise<DocumentParticipantsResponse> => {
    console.log('[DocumentSharingAPI] getParticipants - этот метод теперь используется только как fallback');
    
    // Получаем участников и проверяем авторство параллельно
    const [participantsResponse, isAuthorResponse] = await Promise.all([
      api.get(`/DocumentSharing/${knowledgeItemId}/participants`),
      api.get(`/DocumentSharing/${knowledgeItemId}/is-author`)
    ]);
    
    const participants = participantsResponse.data;
    const isAuthor = isAuthorResponse.data;
    
    // Определяем роль текущего пользователя
    const currentUserRole = isAuthor ? DocumentRole.Author : DocumentRole.Editor;
    
    return {
      participants: Array.isArray(participants) ? participants : [],
      isAuthor: isAuthor,
      currentUserRole: currentUserRole
    };
  },

  // Удалить участника
  removeParticipant: async (knowledgeItemId: string, userId: string): Promise<void> => {
    await api.delete(`/DocumentSharing/${knowledgeItemId}/participants/${userId}`);
  },

  // Получить историю активности
  getActivity: async (knowledgeItemId: string): Promise<DocumentActivityLog[]> => {
    const response = await api.get(`/DocumentSharing/${knowledgeItemId}/activity`);
    return response.data;
  },

  // Проверить, является ли пользователь автором
  // DEPRECATED: Используйте кешированные данные из KnowledgeItem.isAuthor
  isAuthor: async (knowledgeItemId: string): Promise<boolean> => {
    console.log('[DocumentSharingAPI] isAuthor - DEPRECATED метод, используйте кешированные данные');
    const response = await api.get(`/DocumentSharing/${knowledgeItemId}/is-author`);
    return response.data;
  }
}; 